import { waLink } from "../lib/whatsapp";
import { MessageSquareText } from "lucide-react";

/**
 * Elegant WhatsApp CTA button — luxury-styled, no chunky green blob.
 * variants: 'primary' (dark navy), 'ghost' (outlined navy on light), 'inverted' (white on dark bg), 'link'
 */
export default function WhatsAppButton({
  message,
  variant = "primary",
  className = "",
  testId = "wa-cta",
  children = "Continue on WhatsApp",
}) {
  const base =
    "inline-flex items-center justify-center gap-2 h-12 px-7 rounded-full text-[12px] tracking-[0.18em] uppercase transition-colors duration-300";
  const variants = {
    primary: "bg-[#0B1F3A] text-white hover:bg-[#C8A96A]",
    ghost: "border border-[#0B1F3A] text-[#0B1F3A] hover:bg-[#0B1F3A] hover:text-white",
    inverted: "border border-white/40 text-white hover:bg-white/10",
    link: "h-auto p-0 text-[#0B1F3A]/80 hover:text-[#C8A96A] rounded-none",
  };
  return (
    <a
      href={waLink(message)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className={`${base} ${variants[variant] || variants.primary} ${className}`}
    >
      <MessageSquareText size={16} strokeWidth={1.25} />
      {children}
    </a>
  );
}
